import React from "react"
import { Div, Text } from "atomize"
import Container from "../atoms/Container"
import PrimaryButton from "../buttons/PrimaryButton"
import { HELP_TIPS } from "../help/guide"
import { GuideLines } from "../help/GuideText"
import { GuideLink } from "../help/HelpTip"

// Le tre righe di un "?" (src/help/HelpTip.js), aperte da una pagina:
// poche, quanto basta per capire senza lasciare quello che si stava
// guardando, e la strada per saperne di più.
function HelpTipModal({ closeModal, tip }) {
	const content = HELP_TIPS[tip]
	if (!content) return null

	return (
		<Container>
			<Text textWeight="bold" textSize="title" m={{ b: "0.75rem" }}>
				{content.title}
			</Text>
			<GuideLines lines={content.lines} />
			<Div
				d="flex"
				align="center"
				justify="space-between"
				style={{ gap: "1rem" }}
				m={{ t: "0.75rem" }}>
				<GuideLink topic={content.topic} />
				<PrimaryButton
					m="0"
					bg="gunmetal_fill"
					textColor="white"
					textSize="subheader"
					text="Ho capito"
					action={closeModal}
				/>
			</Div>
		</Container>
	)
}

export default HelpTipModal
